document.addEventListener('DOMContentLoaded', function() {
    var options = {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        freeScroll: false,
    };
    
    if ( matchMedia('screen and (max-width: 749px)').matches ) {
        options.freeScroll = true;
    }
    
    var flkty = new Flickity( document.querySelector('.product-testimonials-flickity'), options);
});